var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlfaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8381_68143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55059 0.999931C10.7271 0.999931 11.0968 1.8438 11.407 2.68634C11.5372 3.04412 14.5946 11.4166 14.6865 11.6679C14.711 11.738 14.6945 11.8531 14.5867 11.8948C14.4782 11.9358 12.8897 12.5535 12.8017 12.5865C12.7138 12.6203 12.6152 12.5713 12.5835 12.4834C12.5504 12.3967 11.8911 10.5714 11.817 10.3678H7.28552C7.21409 10.5714 6.5468 12.4007 6.51704 12.4834C6.48662 12.5674 6.39205 12.6242 6.29814 12.5865C6.20423 12.5495 4.60975 11.9318 4.51452 11.8948C4.42325 11.8591 4.38159 11.7552 4.41333 11.6679C4.52576 11.3545 7.53682 3.11621 7.69025 2.68634C7.98918 1.85636 8.37143 0.999931 9.55059 0.999931ZM4.17129 15.9812C4.07605 15.9812 4 16.0605 4 16.1571V18.114C4 18.2105 4.07605 18.2886 4.17129 18.2886H14.9253C15.0225 18.2886 15.0985 18.2105 15.0985 18.114V16.1571C15.0985 16.0605 15.0225 15.9812 14.9253 15.9812H4.17129ZM9.54001 3.7339L8.00836 8.33348H11.0968L9.55985 3.7339H9.54001Z",
    fill: "#EE2A23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8381_68143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4545,
    height: 18,
    fill: "white",
    transform: "translate(4 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfaIcon);
export default __webpack_public_path__ + "static/media/alfa-icon.5ebf533baa75c618d46b660c075290b5.svg";
export { ForwardRef as ReactComponent };